import {
  // eslint-disable-next-line no-restricted-imports
  EmptyState as BeyondEmptyState,
  EmptyStateProps as BeyondEmptyStateProps,
} from '@zeiss/beyond-online-react';
import {
  getIllustrationUrl,
  Illustration,
  useBreakpoint,
} from '@zeiss/lib-helpers';

export interface IllustrationConfig {
  img: Illustration;
  /**
   * Only use, if the illustration is not just decorative. For error screens
   * it should normally be not needed, as all the information is on written on
   * the screen.
   *
   * @see {@link https://www.w3.org/WAI/tutorials/images/decorative/}
   */
  imgAlt?: string;
}

interface EmptyStateProps extends BeyondEmptyStateProps {
  illustrationConfig?: IllustrationConfig;
}

const defaultIllustrationConfig: EmptyStateProps['illustrationConfig'] = {
  img: 'ClearedData',
};

// TODO: Create alt text mapper function
export const EmptyState = ({
  description,
  headline,
  illustrationConfig = defaultIllustrationConfig,
  ...rest
}: EmptyStateProps) => {
  const isMinTablet = useBreakpoint('tablet');

  const { img, imgAlt = '' } = illustrationConfig ?? {};

  return (
    <BeyondEmptyState
      align="left"
      data-testid="EmptyState"
      description={description}
      headline={headline}
      illustration={() => (
        <img alt={imgAlt} src={getIllustrationUrl(img, isMinTablet)} />
      )}
      size="m"
      {...rest}
    />
  );
};
